// ============================================================================
// dto-adapters — DTO gest (camelCase strippe) -> types lib (buildEmployeeLines)
// ============================================================================
// Le DTO gest strippe des champs que le PoC (payload serveur Next) portait :
// GridPosition sans created_at/updated_at ; EchelonChange sans id/email/
// evaluation_id/changed_by_email (M-657/timestamps). buildEmployeeLines ne LIT que
// class_id/echelon/source/year (positions) et effective_year/from_echelon/
// to_echelon (historique) — les champs manquants sont des shims de type inertes.
// Meme categorie que `adaptGridClasses` (SL-A) : le pont vit cote CLIENT, le
// serveur est fige. AUCUNE donnee inventee n'est affichee. Partage L05
// (DirectorGridBoard, SL-B) + L06 (GrilleSalarialePage, GC-B) — source unique.

import type {
  EchelonChange,
  EchelonChangeReason,
  GridPosition,
} from '../types/firestore';
import type {
  PlanningGridPosition,
  PlanningEchelonChange,
} from '../../hooks/usePlanification';

/** Positions passees DTO -> GridPosition[] (shims created_at/updated_at inertes). */
export function toLibPast(
  rec: Record<string, PlanningGridPosition[]>,
): Record<string, GridPosition[]> {
  const out: Record<string, GridPosition[]> = {};
  for (const [email, arr] of Object.entries(rec)) {
    out[email] = arr.map((p) => ({
      email: p.email,
      year: p.year,
      class_id: p.class_id,
      echelon: p.echelon,
      source: p.source,
      note: p.note,
      entered_by_email: p.entered_by_email,
      created_at: '',
      updated_at: '',
    }));
  }
  return out;
}

/** Historique d'echelon DTO -> EchelonChange[] ; ecarte les entrees sans annee d'effet
 * (aucune ligne passee positionnable) ; shims id/email/evaluation_id inertes. */
export function toLibHistory(
  rec: Record<string, PlanningEchelonChange[]>,
): Record<string, EchelonChange[]> {
  const out: Record<string, EchelonChange[]> = {};
  for (const [email, arr] of Object.entries(rec)) {
    out[email] = arr
      .filter((c) => c.effective_year !== null)
      .map((c) => ({
        id: '',
        email,
        from_echelon: c.from_echelon,
        to_echelon: c.to_echelon,
        effective_year: c.effective_year as number,
        reason: c.reason as EchelonChangeReason,
        evaluation_id: null,
        changed_by_email: '',
        created_at: c.created_at,
      }));
  }
  return out;
}
